export const DEFAULT_MIN = 0;
export const DEFAULT_MAX = 2147483647;
export const DEFAULT_TRANSLATIONS = {
    value: 'value',
};
export const ALLOWED_DECIMAL_SEPARATORS = ['.', ','];
